"use client"

import type { MerchantConfig } from "@/data/merchant-types"

interface ShopkeepPortraitSectionProps {
  scale: number
  merchant: MerchantConfig | null // Add merchant prop
}

export const ShopkeepPortraitSection = ({ scale, merchant }: ShopkeepPortraitSectionProps) => {
  const effectiveScale = scale || 1
  const width = 72 * effectiveScale
  const height = 72 * effectiveScale
  const right = 19 * effectiveScale
  const top = 26 * effectiveScale

  const shopkeepImage = merchant?.portraitImage || "/images/shopkeep-1.png"

  return (
    <div
      id="shopkeep-portrait-section"
      className="absolute"
      style={{
        right,
        top,
        width,
        height,
        zIndex: 10,
      }}
    >
      <div className="w-full h-full relative overflow-hidden">
        <img
          src={shopkeepImage || "/placeholder.svg"}
          alt="Shopkeeper"
          className="absolute inset-0 w-full h-full object-cover"
          style={{ imageRendering: "pixelated" }}
        />
      </div>
    </div>
  )
}
